import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

import { Employee } from '../../models/Employee';
import { EmployeeService } from './../../services/employee.service';
import { AppSnackbarComponent } from './../../helpers/app-snackbar.component';

@Component({
  selector: 'app-employee-form',
  templateUrl: './employee-form.component.html',
  styleUrls: ['./employee-form.component.css'],
  providers: [EmployeeService]
})
export class EmployeeFormComponent implements OnInit {
  employee: Employee;
  dirty: boolean;
  loading: boolean;
  @ViewChild('f') form: any;
  constructor(
    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    let empNo = +this.route.snapshot.paramMap.get('id');
    if (empNo) {
      this.employeeService.getEmployee(empNo).subscribe(result => {
        console.log(result);
        this.employee = new Employee(result.employee);
      })
    } else {
      this.employee = new Employee();
    }
  }

  ngAfterViewInit() {
  }

  persist() {
    console.log('============== save')
    console.log(this.employee)
    this.loading = true;
    setTimeout(() => {
      this.employeeService.persist(this.employee).subscribe(result => {
        console.log(result);
        let zzz = this.snackBar.openFromComponent(AppSnackbarComponent, {
          duration: 3000,
          extraClasses: [result.success ? 'snack-bar-success-class' : 'snack-bar-danger-class']
        });
        zzz.instance.content = 'operazione ' + (result.success ? 'completata' : 'fallita');
        this.loading = false;
      })
    }, 1000);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/employee-form/employee-form.component.ts